import { createSlice } from '@reduxjs/toolkit'
import { fetchNavLinks } from './thunks'
import type { SidebarNavLink } from './types'
import type { RootState } from '..'
type SidebarInitialState = {
	navLinks: SidebarNavLink[]
	navError: string
	loading: boolean
}
const initialState: SidebarInitialState = {
	navLinks: [],
	navError: '',
	loading: false,
}

export const sidebarSlice = createSlice({
	name: 'sidebar',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchNavLinks.rejected, state => {
			state.loading = false
			state.navError = 'Error loading navigation links'
		})
		builder.addCase(fetchNavLinks.pending, state => {
			state.loading = true
		})
		builder.addCase(fetchNavLinks.fulfilled, (state, action) => {
			const { navLinks } = action.payload
			state.navLinks = navLinks
			state.loading = false
		})
	},
})

export const selectSidebar = (state: RootState) => state.sidebar

export const sidebarReducer = sidebarSlice.reducer
